export const getConsentPolicy = () => {
  if (!window.consentPolicyManager) {
    console.log(
      "[site-bi] Couldn't get current consent policy because consentPolicyManager is missing",
    );

    return;
  }

  const res = window.consentPolicyManager.getCurrentConsentPolicy();

  console.log('[site-bi] Got consent policy', res);

  return res;
};
